import { render, staticRenderFns } from "./shopClassifySelector.vue?vue&type=template&id=d8e7ee54"
import script from "./shopClassifySelector.vue?vue&type=script&lang=js"
export * from "./shopClassifySelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports